<template>
	<header class="suntop_header">
	   <div class="in">
	      <div class="in_relative">
	         <div class="logo">
	            <a href="#home" v-scroll-to="'#home'">
	               <img :src="$t('loading_logo')">
	            </a>
	         </div>
	         <div class="navigation_list_wrap">
	            <div class="menu">
			        <scrollactive ref="scrollactive" active-class="current" :offset="offset" :always-track="alwaysTrack" :duration="duration" :click-to-scroll="clickToScroll" v-on:itemchanged="onItemChanged" :bezier-easing-value="easing">
						<ul class="anchor_nav">
						      <li><a class="scrollactive-item" v-on:click="menu('Home')" href="#home" v-scroll-to="'#home'">{{ $t('home') }}</a></li>
							  <li><a class="scrollactive-item" v-on:click="menu('Winners')" href="#prizes" v-scroll-to="'#prizes'">{{ $t('winners') }}</a></li>
							  <li><a class="scrollactive-item" v-on:click="menu('Redemption')" href="#redemption" v-scroll-to="'#weekly'">{{ $t('redemption_centers') }}</a></li>
						</ul>
					</scrollactive>
	            </div>
	            <div class="suntop_lang">
					<locale-dropdown />
					<a class="button go-back" href="/" target="_self">
						{{ $t('go_back') }}
					</a>
	            </div>
	            <div class="suntop_trigger">
					<nav role="navigation">
					    <div id="menuToggle">
					      <input type="checkbox" id="mobile_nav"/>
					        <span></span>
					        <span></span>
					        <span></span>
						    <ul id="menu" class="opacity">
						      <li style="border-top: 1px #ffffff solid;"><a v-on:click="burger('Home')" href="#home" v-scroll-to="'#home'">{{ $t('home') }}</a></li>
						      <li><a v-on:click="burger('Winners')" href="#prizes" v-scroll-to="'#prizes'">{{ $t('winners') }}</a></li>
						      <li><a v-on:click="burger('Redemption')" href="#redemption" v-scroll-to="'#redemption'">{{ $t('redemption_centers') }}</a></li>
						    </ul>
					   </div>
					</nav>
	            </div>
	         </div>
	      </div>
	   </div>
	</header>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'

const Vue = window.vue;

export default {
  components: {
    LocaleDropdown
  },

  data: () => ({
	isActive: false,
    appName: window.config.appName,
    elements: [],
    alwaysTrack: false,
    duration: 600,
    clickToScroll: true,
    offset: 80,
    easing: '.5,0,.35,1',
  }),
  computed: {
    ...mapGetters({
	    user: 'auth/user'
    }),
    numberOfElements() {
      return this.elements.length;
    }
  },
  mounted() {
    this.elements = this.$el.querySelectorAll('.scrollactive-item');

	$("#mobile_nav").click(function() {
		$("#menu").toggleClass('active');
		if ($('#menu').hasClass('opacity')) {
			$("#menu").toggleClass('opacity');
		} else {
			if($('#menu').hasClass('active')){

			} else {
				setTimeout(function(){ $("#menu").toggleClass('opacity'); }, 150);
			}
		}
	});
  },
  methods: {
	onItemChanged(event, currentItem, lastActiveItem) {
		jQuery(lastActiveItem).parent('li').removeClass('current');
		jQuery(currentItem).parent('li').addClass('current');
	},
	burger (name) {
		$("#menu").toggleClass('active');
		if ($('#menu').hasClass('opacity')) {
			$("#menu").toggleClass('opacity');
		} else {
			if($('#menu').hasClass('active')){

			} else {
				setTimeout(function(){ $("#menu").toggleClass('opacity'); }, 150);
			}
		}
		$("#mobile_nav").prop( "checked", false );
        this.$ga.event('CTA', 'Mobile Navigation', name, 1);
	},
	menu (name) {
		$("#menu").toggleClass('active');
		if ($('#menu').hasClass('opacity')) {
			$("#menu").toggleClass('opacity');
		} else {
			if($('#menu').hasClass('active')){

			} else {
				setTimeout(function(){ $("#menu").toggleClass('opacity'); }, 150);
			}
		}
		$("#mobile_nav").prop( "checked", false );
        this.$ga.event('CTA', 'Desktop Navigation', name, 1);
	},
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
.ltr .go-back{
	position: absolute;top: 0;right: 80px;font-size: 0.8em;height: 40px;width: 110px;text-decoration: none;
}
.rtl .go-back{
	position: absolute;top: 0;left: 80px;font-size: 0.8em;height: 40px;width: 110px;text-decoration: none;
}
</style>
